/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var linear = function linear(current, start, end, duration) {
  var change = end - start;
  var offset = change * current / duration;
  return offset + start;
};
var easeInOutCubic = function easeInOutCubic(current, start, end, duration) {
  var change = (end - start) / 2;
  var time = current / (duration / 2);
  if (time < 1) {
    return change * time * time * time + start;
  }
  time -= 2;
  return change * (time * time * time + 2) + start;
};

export { easeInOutCubic, linear };
//# sourceMappingURL=easing.mjs.map
